import AsyncButton from '../../../../../../../shared/Loading/AsyncButton';

const ThemeIcon = ({ activeTheme }) => {
  if (activeTheme === 'dark') {
    // Luna (tema oscuro activo)
    return (
      <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 text-white" fill="currentColor" aria-hidden="true">
        <path d="M20 15.5A8 8 0 0 1 8.5 4 8.5 8.5 0 1 0 20 15.5z" />
      </svg>
    );
  }

  // Sol (tema claro activo)
  return (
    <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 text-amber-500" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
      <circle cx="12" cy="12" r="4" fill="currentColor" stroke="none" />
      <path d="M12 2v2M12 20v2M4 12H2M22 12h-2M5 5l1.5 1.5M17.5 17.5L19 19M19 5l-1.5 1.5M6.5 17.5L5 19" strokeLinecap="round" />
    </svg>
  );
};

const Menu = (props) => {
  const initials = `${props.currentUser?.FirstName?.charAt(0) ?? ''}${props.currentUser?.LastName?.charAt(0) ?? ''}`;
  const activeTheme = props.theme || 'light';
  const nextTheme = activeTheme === 'dark' ? 'light' : 'dark';
  const isDark = activeTheme === 'dark';
  const handleThemeChange = () => {
    props.setTheme?.(nextTheme);
  };

  return (
    props.menuOpen && (
      <div
        ref={props.menuRef}
        id="user-menu"
        role="menu"
        aria-label="Menu de usuario"
        className="absolute right-0 top-full z-50 mt-3 w-72 origin-top-right overflow-hidden rounded-lg
          border border-gray-200 bg-white text-gray-900 shadow-xl ring-1 ring-black/5"
      >
        <div className="flex items-center gap-3 px-4 py-4">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-personalized text-sm font-bold text-white">
            {initials}
          </div>
          <div className="min-w-0">
            <p className="truncate text-sm font-semibold text-gray-900">
              {props.currentUser?.FirstName} {props.currentUser?.LastName}
            </p>
            <p className="truncate text-xs text-gray-500">
              {props.currentUser?.PrincipalEmail}
            </p>
          </div>
        </div>
        <div className="h-px bg-gray-100" />
        <button
          type="button"
          role="menuitem"
          onClick={handleThemeChange}
          className="group flex w-full items-center justify-between px-4 py-3 text-left text-sm font-medium text-gray-700 transition
            hover:bg-purple-50 hover:text-personalized focus:outline-none
            focus-visible:bg-purple-50 focus-visible:text-personalized"
          aria-label={`Cambiar a tema ${nextTheme === 'dark' ? 'oscuro' : 'claro'}`}
          aria-pressed={isDark}
        >
          <span>Tema</span>
          {/* Toggle: punto que se desliza; el ícono (sol/luna) va en el espacio libre al lado del punto */}
          <span
            className={`relative inline-flex h-7 w-14 shrink-0 items-center rounded-full p-0.5 transition-colors duration-300
              ${isDark ? 'bg-personalized' : 'bg-gray-300'}`}
          >
            <span className={`pointer-events-none absolute inset-y-0 flex items-center ${isDark ? 'left-2' : 'right-2'}`}>
              <ThemeIcon activeTheme={activeTheme} />
            </span>
            <span
              className={`relative z-10 inline-block h-6 w-6 transform rounded-full bg-white shadow transition-transform duration-300
                ${isDark ? 'translate-x-7' : 'translate-x-0'}`}
            />
          </span>
        </button>
        <div className="h-px bg-gray-100" />
        <AsyncButton
          role="menuitem"
          onClick={props.onLogout}
          light
          className="w-full px-4 py-3 text-left text-sm font-medium text-gray-700 transition
            hover:bg-purple-50 hover:text-personalized focus:outline-none
            focus-visible:bg-purple-50 focus-visible:text-personalized"
        >
          Cerrar sesion
        </AsyncButton>
      </div>
    )
  );
};

export default Menu;
